export const KOREAN = "ko";
export const ENGLISH = "en";
export const VIETNAMESE = "vi";
